"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IssueStatus = exports.IssueSortingField = exports.IssueSortingDirection = exports.IssuePlacementType = exports.IssueDateFilters = void 0;
let IssueStatus = exports.IssueStatus = /*#__PURE__*/function (IssueStatus) {
  IssueStatus["Draft"] = "draft";
  IssueStatus["Open"] = "open";
  IssueStatus["Pending"] = "pending";
  IssueStatus["InProgress"] = "in_progress";
  IssueStatus["Completed"] = "completed";
  IssueStatus["InReview"] = "in_review";
  IssueStatus["NotApproved"] = "not_approved";
  IssueStatus["InDispute"] = "in_dispute";
  IssueStatus["Closed"] = "closed";
  return IssueStatus;
}({});
let IssueSortingField = exports.IssueSortingField = /*#__PURE__*/function (IssueSortingField) {
  IssueSortingField["DisplayId"] = "displayId";
  IssueSortingField["Title"] = "title";
  IssueSortingField["Description"] = "description";
  IssueSortingField["Status"] = "status";
  IssueSortingField["AssignedToType"] = "assignedToType";
  IssueSortingField["DueDate"] = "dueDate";
  IssueSortingField["StartDate"] = "startDate";
  IssueSortingField["LocationDetails"] = "locationDetails";
  IssueSortingField["ClosedAt"] = "closedAt";
  IssueSortingField["CreatedAt"] = "createdAt";
  IssueSortingField["ClientCreatedAt"] = "clientCreatedAt";
  IssueSortingField["UpdatedAt"] = "updatedAt";
  IssueSortingField["OpenedAt"] = "openedAt";
  IssueSortingField["DeletedBy"] = "deletedBy";
  IssueSortingField["DeletedOn"] = "deletedAt";
  IssueSortingField["RootCause"] = "rootCause";
  IssueSortingField["IssueType"] = "issueSubType";
  IssueSortingField["IssueTypeCategory"] = "issueType";
  IssueSortingField["Published"] = "published";
  return IssueSortingField;
}({});
let IssueSortingDirection = exports.IssueSortingDirection = /*#__PURE__*/function (IssueSortingDirection) {
  IssueSortingDirection["Asc"] = "asc";
  IssueSortingDirection["Desc"] = "desc";
  return IssueSortingDirection;
}({});
/**
 * DateFilter can be an ISO string of a date, format YYYY-MM-DD, an ISO String date and time, or null
 */
const IssueDateFilters = exports.IssueDateFilters = ["dueDate", "startDate", "createdAt", "openedAt", "updatedAt", "closedAt"];
let IssuePlacementType = exports.IssuePlacementType = /*#__PURE__*/function (IssuePlacementType) {
  IssuePlacementType["FILE"] = "file";
  IssuePlacementType["SHEET"] = "sheet";
  return IssuePlacementType;
}({});
//# sourceMappingURL=Issue.js.map